import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const STATUS_STYLE = {
  pending: { bg: "#d93025", fg: "#fff", label: "A fazer" },
  done: { bg: "#33b679", fg: "#fff", label: "Concluído" },
  overdue: { bg: "#f6bf26", fg: "#3c2a00", label: "Atrasado" },
};

export const KIND_META = {
  evento: { label: "Evento", color: "#1a73e8" },
  lembrete: { label: "Lembrete", color: "#8e24aa" },
};

export const FREQ_LABEL = {
  none: "Não se repete",
  daily: "Todos os dias",
  weekly: "Toda semana",
  monthly: "Todo mês",
  yearly: "Todo ano",
};

export const WEEK_LETTERS = ["D", "S", "T", "Q", "Q", "S", "S"];
export const MONTHS_SHORT = ["jan.", "fev.", "mar.", "abr.", "mai.", "jun.", "jul.", "ago.", "set.", "out.", "nov.", "dez."];

const pad = (n) => String(n).padStart(2, "0");
export const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const fromISO = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const todayISO = () => toISO(new Date());

export const monthGrid = (year, month) => {
  const first = new Date(year, month, 1);
  const start = addDays(first, -first.getDay());
  return Array.from({ length: 42 }, (_, i) => addDays(start, i));
};

export const recurrenceText = (o) => {
  if (!o.freq || o.freq === "none") return "Não se repete";
  let t = FREQ_LABEL[o.freq];
  if (o.count) t += `, ${o.count} vezes`;
  else if (o.until) t += ` até ${fromISO(o.until).toLocaleDateString("pt-BR")}`;
  return t;
};

export const longDate = (iso) =>
  fromISO(iso).toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "short" });

export const useOccurrences = (start, end) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(() => {
    setLoading(true);
    return api.get("/calendar/occurrences", { params: { start, end } })
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [start, end]);
  useEffect(() => { reload(); }, [reload]);
  return { items, loading, reload };
};
